import { axiosInstance } from '../context/AuthContext';

export const savedArtworksApi = {
  getSavedArtworks: async () => {
    const response = await axiosInstance.get('/user/saved-artworks/saved');
    return response.data;
  },

  toggleSaveArtwork: async (artworkId) => {
    const response = await axiosInstance.post('/user/saved-artworks/saved/toggle', {
      artworkId,
    });
    return response.data;
  },

  checkIfSaved: async (artworkId) => {
    const response = await axiosInstance.get(
      `/user/saved-artworks/saved/check/${artworkId}`
    );
    return response.data;
  },
};
